import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { AccordionElementBase } from '../../lit-mixins/accordion-element-base/index.js';
import { renderImageAccordionItem } from './layout/renderImageAccordionItem.js';
import css_248z from './image-accordion-item.scss.js';

let ImageAccordionItem = class ImageAccordionItem extends AccordionElementBase(s) {
    render() {
        return this.renderAccordionElement(renderImageAccordionItem(this));
    }
};
ImageAccordionItem.styles = css_248z;
ImageAccordionItem = __decorate([
    n('image-accordion-item')
], ImageAccordionItem);

export { ImageAccordionItem };
